import { render, staticRenderFns } from "./BumpsLocationTemplate.vue?vue&type=template&id=52526205"
import script from "./BumpsLocationTemplate.vue?vue&type=script&lang=js"
export * from "./BumpsLocationTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports